'use strict';

var _ = require('underscore');
var Backbone = require('backbone');
var moment = require('moment-timezone');

var GroupAppointment = require('../models/group-appointment').default;

export default Backbone.Collection.extend({

  url: '/online_bookings/ajax_times',
  model: GroupAppointment,

  parse: function (response) {
    var appointments = [];
    if (!response.data) return appointments;
    if (!response.data.availability) return appointments;
    if (!response.data.availability.dates) return appointments;
    if (!response.data.availability.dates.date) return appointments;

    _.each(response.data.availability.dates.date, function (date) {
      _.each(date.time, function (time) {
        _.each(time.staff, function (staff) {
          appointments.push({
            id: staff.appointment,
            start: date.value + ' ' + time.start,
            staff_id: staff.id,
            attendee_count: staff.attendee.count,
            attendee_limit: staff.attendee.limit,
          });
        });
      });
    });

    return appointments;
  },

  adjustWithTimezone: function (appointment) {
    const sourceTimezone = appointment.getLocation().get('timezone');
    const destTimezone = window.localStorage.getItem('timezone');
    const models = [];

    this.each((model) => {
      const timestamp = model.get('start');
      const originalStart = moment.tz(timestamp, sourceTimezone);

      model.set('adjusted_start', originalStart.clone().tz(destTimezone));
      model.set('timezone_abbr', moment.tz(destTimezone).zoneAbbr());
      models.push(model);
    });

    return models;
  },
});
